module.exports = __webpack_public_path__ + "static/media/heart.d77f1cd0.svg";